import * as React from 'react';
import AppContainer from "../../containers/Container/App/Main";
import DynamicTable from "../../containers/DataTable/DynamicTable/DynamicTable";
import RoleForm from "../Role/Form/RoleForm";
import {useEffect, useState} from "react";
import {setupCrud} from "../../helpers/setupCrud";
import {useStore} from "../../stores/store";
import {useHistory} from "react-router-dom";

const columnHeader = [
  {
    id: "status_id",
    renderType: 'render|status',
    align: 'left',
    disablePadding: false,
    label: "Status",
    setWidth: '13%'
  },
  {
    id: "code",
    renderType: 'default',
    align: 'left',
    disablePadding: false,
    label: "Code",
    setWidth: '20%',
    searchable: true,
    searchType: 'text'
  },
  {
    id: "name",
    renderType: 'default',
    align: 'left',
    disablePadding: false,
    label: "Name",
    setWidth: '15%',
    searchable: true,
    searchType: 'text'
  },
  // {
  //   id: "position_id_escort",
  //   renderType: 'render|position',
  //   align: 'left',
  //   disablePadding: false,
  //   label: "Position Escort",
  //   setWidth: '15%',
  //   searchable: true,
  //   searchType: 'select|position',
  // },
  {
    id: "valid_from_date",
    renderType: 'date|no_start',
    align: 'left',
    disablePadding: false,
    label: "Valid From",
    setWidth: '10%',
  },
  {
    id: "valid_to_date",
    renderType: 'date|no_expiry',
    align: 'left',
    disablePadding: false,
    label: "Valid To",
    setWidth: '10%',
  },
  {id: "action", renderType: 'default', align: 'right', disablePadding: false, label: "", setWidth: '17%'},
];

const AdminRole = (props) => {
  const {path} = props;
  const {state} = useStore();
  const [crud, setCrud] = useState([]);
  const buttonEndpoint = 'api/v1/role/';
  let sortBy = "id";
  let history = useHistory();

  useEffect(() => {
    setCrud(setupCrud(path, state.user_data.menu.admin));
  }, [state.user_data.menu_updated]);

  if(typeof crud.read !== 'undefined' && !crud.read) {
    history.push("/404");
  }

  return (
    <AppContainer>
      <DynamicTable
        tableTitle={'Roles'}
        filter={!!(crud.read)}
        headCells={columnHeader}
        sortBy={sortBy}
        addButton={!!(crud.create)}
        editButton={!!(crud.update)}
        deleteButton={!!(crud.delete)}
        buttonEndpoint={buttonEndpoint}
        modalWidth={'md'}
        form={<RoleForm/>}
      />
    </AppContainer>
  );
}

export default AdminRole;